import {CaretDown, CaretLineDown, CaretUp} from '@phosphor-icons/react';
import {Collapse, theme} from 'antd';

import React, {useState} from 'react';

const {Panel} = Collapse;

const Colapse = ({items}: {items: {key: string; label: string; children: React.ReactNode}[]}) => {
	const [activeKeys, setActiveKeys] = useState<string[]>(['1']);
	const {token} = theme.useToken();
	const onChange = (keys: string | string[]) => {
		setActiveKeys(typeof keys === 'string' ? [keys] : keys);
	};
	return (
		<Collapse
			// accordion={true}
			bordered={false}
			activeKey={activeKeys}
			onChange={onChange}
			style={{background: token.colorBgContainer}}
			expandIcon={({isActive}) =>
				isActive ? <CaretUp size={24} color="#000000" /> : <CaretDown size={24} color="#000000" />
			}
			expandIconPosition="end">
			{items.map(item => (
				<Panel key={item.key} header={item.label}>
					{item.children}
				</Panel>
			))}
		</Collapse>
	);
};

export default Colapse;
